export const formatValue = (value, kind = "number") => {
  if (kind === "raw") return value ?? "N/A";
  if (value === null || value === undefined) return "N/A";
  if (kind === "percent") return `${Number(value).toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
  if (kind === "ms") {
    if (value >= 1000) return `${(value / 1000).toFixed(2)}s`;
    return `${Math.round(value)}ms`;
  }
  if (kind === "cls") return Number(value).toFixed(3);
  if (kind === "decimal") {
    const n = Number(value);
    if (Number.isNaN(n)) return "N/A";
    return n.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }
  const n = Number(value);
  if (Number.isNaN(n)) return "N/A";
  if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}K`;
  return n.toLocaleString(undefined, { maximumFractionDigits: 1 });
};

/** "1 visit" / "4 visits" — unit should be the plural form. */
export const formatCountLabel = (value, unit) => {
  const formatted = formatValue(value, "number");
  if (!unit) return formatted;
  const n = Number(value) || 0;
  const singular = unit.endsWith("s") ? unit.slice(0, -1) : unit;
  return `${formatted} ${n === 1 ? singular : unit}`;
};

/**
 * CF RUM often zeros low-volume daily buckets while period totals still show.
 * Park the period total on the last day so sparklines aren't a blank flat line.
 */
export const withSparseSeriesFallback = (series, value) => {
  if (!series?.length) return series || [];
  const sum = series.reduce((acc, point) => acc + (Number(point.value) || 0), 0);
  if (sum > 0 || !value) return series;
  return series.map((point, index) => (
    index === series.length - 1 ? { ...point, value } : point
  ));
};

export const formatChange = (change) => {
  if (change === null || change === undefined || Number.isNaN(change)) return null;
  const rounded = Math.round(change);
  if (rounded === 0) return "0%";
  return `${rounded > 0 ? "+" : ""}${rounded}%`;
};

export const changePercent = (value, previous) => {
  if (!previous) return null;
  return ((value - previous) / previous) * 100;
};

/** Keeps TLD so redacted cards still feel like real domains when shared. */
export const redactHostname = (hostname) => {
  if (!hostname) return { label: "••••••.com", tld: ".com" };
  const host = String(hostname);
  const lower = host.toLowerCase();
  // Platform subdomains: show .weave.md / .dock.md, not just .md
  const platform = [".weave.md", ".dock.md"].find((suffix) => lower.endsWith(suffix));
  const parts = host.split(".");
  const tld = platform || (parts.length > 1 ? `.${parts[parts.length - 1]}` : "");
  return { label: null, tld, length: Math.max(host.length - tld.length, 1) };
};
